import { render } from "./PeriodontalPreview.vue?vue&type=template&id=f767476e&scoped=true&ts=true"
import script from "./PeriodontalPreview.vue?vue&type=script&lang=ts"
export * from "./PeriodontalPreview.vue?vue&type=script&lang=ts"

import "./PeriodontalPreview.vue?vue&type=style&index=0&id=f767476e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f767476e"]])

export default __exports__